/**
 * Tooltips based on REST API
 */
class Kosmopedia_Tooltips {
    constructor() {
        if (!$('body.single-encyklopedia, body.single-pojecia, body.page, body.single').length) {
            return;
        }

        this.loadData();
    }

    loadData() {
        let links = document.querySelectorAll('article.text-content a');
        links = Array.from(links).map(link => $(link).attr('href')).filter(url => url.indexOf('http') === 0 && url.indexOf('/encyklopedia/') > -1 || url.indexOf('/pojecia/') > -1);
        links = [...new Set(links)].join(';');

        $.ajax({
            url: window.kosmopedia.siteUrl + '/wp-json/kosmopedia/v1/tooltips',
            method: 'post',
            data: {
                urls: links
            }
        }).done(response => {
            this.initTooltipsContent(response);
        });
    }

    initTooltipsContent (apiResponse) {
        for (let i = 0; i < apiResponse.length; i++) {
            let linksToBind = document.querySelectorAll('article.text-content a[href^="' + apiResponse[i].url + '"]');

            for (let j = 0; j < linksToBind.length; j++) {
                let tooltip = $('<span class="kosmopedia-tooltip"><strong class="kosmopedia-tooltip-title"></strong><span class="kosmopedia-tooltip-text"></span></span>');
                tooltip.find('.kosmopedia-tooltip-title').text(apiResponse[i].title);
                tooltip.find('.kosmopedia-tooltip-text').text(apiResponse[i].content);
                tooltip.appendTo($(linksToBind[j]));
            }
        }
    }
}
